export default "__VITE_ASSET__Gb4M7Xje__"